export const gaEventTracker = (category: string, action: string, label: string) => {
  // @ts-ignore
  dataLayer.push({event: 'GAEvent', event_category: category, event_action: action, event_label: label})
}

export const googleAdsTracker = ({ value = '', itemIds }: { value?: string | number, itemIds?: string[]} ) => {
  try {
    // @ts-ignore
    if (!window.gtag) return
    let items: {id: string, google_business_vertical: string }[] = []
    if (itemIds) {
      items = itemIds.map(id => {
        return {
          id,
          'google_business_vertical': 'retail'
        }
      })
    }
    // @ts-ignore
    window.gtag('event', 'page_view', {
      'send_to': 'AW-10813193814',
      'value': value,
      'items': items
    })
  } catch (error) {
    throw new Error('googleAdsTracker: ' + error)
  }
}
type RaksulBQPayload = {
  eventName: string
  data: any
}
const raksulAnalyticSendEvent = (payload: RaksulBQPayload) => {
  // @ts-ignore
  window.raksulDataCollector.sendEvent(payload.eventName, payload.data)
}
const MAX_RETRY_TIME_RAKSUL_TRACKING = 5
export const raksulBQEventTracker = (payload: RaksulBQPayload) => {
  try {
    const events: RaksulBQPayload[] = []
    let retry = 0
    const sendEventInterval = () => {
      const eventInterval = setInterval(() => {
        // @ts-ignore
        if (window.raksulDataCollector) {
          while (events.length) {
            const item = events.pop()
            if (item) raksulAnalyticSendEvent(item)
          }
          clearInterval(eventInterval)
        }
        retry++
        if (retry === MAX_RETRY_TIME_RAKSUL_TRACKING) clearInterval(eventInterval)
      }, 1000)
    }
    // @ts-ignore
    if (window.raksulDataCollector) {
      raksulAnalyticSendEvent(payload)
    } else {
      events.push(payload)
      sendEventInterval()
    }
  } catch (error) {
    throw new Error('raksulBQEventTracker: ' + error)
  }

}

export const EVENT_CATEGORIES = {
  PRODUCT_DETAIL: 'product_detail',
  EDITOR: 'editor',
  SEARCH: 'search',
  SIMULATOR: 'simulator'
}

export const EVENT_ACTIONS = {
  CLOSE: 'close',
  COMPLETE: 'complete',
  GUIDE: 'guide',
  LINK_COPY: 'link_copy',
  NEXT: 'next',
  OPEN: 'open',
  OPEN_DIALOG: 'open_dialog',
  SKIP: 'skip',
  SHARE_EMAIL: 'share_email',
  SHARE_FACEBOOK: 'share_facebook',
  SHARE_LINE: 'share_line',
  SHARE_TWITTER: 'share_twitter',
  PROCEED: 'proceed',
  CLICK: 'click',
  CHANGE: 'change',
  UPLOAD: 'upload',
  ERROR: 'error',
  LOG: 'log'
}

export const EVENT_LABELS = {
  SHARE_IN_IMAGE: 'share_in_image',
  SHARE_DIALOG: 'share_dialog',
  SHARE_IN_DIALOG: 'share_in_dialog',
  SHARE_IN_EDIT_DISPLAY: 'share_in_editDisplay',
  ONBOARDING_START_DIALOG: 'onboarding_start_dialog',
  LOGO_TEXT_ADD_CENTER: 'logo_text_add_center',
  LOGO_TEXT_ADD_LEFT_TOP: 'logo_text_add_leftTop',
  COLOR_PATTERN_CHANGE: 'color_pattern_change',
  EDIT_PATTERN_CHANGE: 'edit_pattern_change',
  TEXT_CHANGE: 'text_change',
  DESIGN_PREVIEW_OPEN: 'design_preview_open',
  DESIGN_PC_SHARE: 'design_pc_share',
  PC_SECOND_COLUMN_UPPER: 'pc_second_column_upper',
  PC_SECOND_COLUMN_LOWER: 'pc_second_column_lower',
  MOBILE_SECOND_COLUMN_UPPER: 'mobile_second_column_upper',
  MOBILE_SECOND_COLUMN_LOWER: 'mobile_second_column_lower',
  PC_THREE_COLUMN_UPPER: 'pc_three_column_upper',
  PC_THREE_COLUMN_LOWER: 'pc_three_column_lower',
  MOBILE_THREE_COLUMN_UPPER: 'mobile_three_column_upper',
  MOBILE_THREE_COLUMN_LOWER: 'mobile_three_column_lower',
  SEARCH_RESULT_CLICK: 'search_result_click',
  PRODUCT_SEARCH_TAG_CLICK: 'product_search_tag_click',
  CHANGE_PREFECTURE: 'change_delivery_prefecture',
  EDITOR_CROP_CLICK: 'editor_crop_click',
  EDITOR_CROP_CONFIRM: 'editor_crop_confirm',
  EDITOR_TOGGLE_TRANSPARENT: 'editor_toggle_transparent',
  UPLOAD_AT_SIMULATOR: 'upload_at_simulator',
  UPLOAD_AT_EDITOR: 'upload_at_editor'
}

export const BQ_EVENT_NAMES = {
  SEARCH_KEYWORD: 'searchKeyword',
  SEARCH_RESULT_CLICK: 'clickSearchResult',
  PRODUCT_SEARCH_TAG_CLICK: 'apparel_productSearchTagClick',
  SUBMISSION_CREATED_FROM_SIMULATOR: 'apparel_submissionCreatedFromSimulator',
  PRODUCT_DETAIL_PROCESS_ERROR: 'apparel_ProductDetailError',
  CHANGE_PREFECTURE: 'apparel_changeDeliveryPrefecture',
  UPLOAD_AT_SIMULATOR: 'apparel_UploadAtSimulator',
  UPLOAD_AT_EDITOR: 'apparel_UploadAtEditor',
  CART_NOW: 'apparel_CartNow'
}

export const SEARCH_TRACKING_QUERY = 'trackingSearch'
